import React from 'react';
import { NavLink } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';

const OVER_NLBA_LINKS = [
  { to: '/over-nlba/waarom-kies-je-voor-ons', label: 'Waarom kies je voor ons' },
  { to: '/over-nlba/accreditatie', label: 'Accreditatie' },
  { to: '/over-nlba/reviews', label: 'Reviews' },
  { to: '/over-nlba/ons-team', label: 'Ons Team' },
  { to: '/over-nlba/organogram', label: 'Organogram' }
];

const OverNLBADetailLayout = ({ title, subtitle, heroImage, heroAlt, children }) => {
  return (
    <div className="over-nlba-page">
      <Navbar />
      <section className="over-nlba-section">
        <div className="over-nlba-container">
          <figure className="over-nlba-detail-hero-wrap">
            <img src={heroImage} alt={heroAlt || title} className="over-nlba-detail-hero" loading="lazy" />
            <figcaption className="over-nlba-detail-hero-caption">
              <h1>{title}</h1>
              {subtitle && <p>{subtitle}</p>}
            </figcaption>
          </figure>

          <div className="over-nlba-detail-layout">
            <aside className="over-nlba-side-wrap">
              <p className="over-nlba-side-label">Over NLBA</p>
              <ul className="over-nlba-side-nav">
                {OVER_NLBA_LINKS.map((item) => (
                  <li key={item.to}>
                    <NavLink
                      to={item.to}
                      className={({ isActive }) => `over-nlba-side-link${isActive ? ' active' : ''}`}
                    >
                      {item.label}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </aside>

            <main>
              <div className="over-nlba-content-panel">{children}</div>
            </main>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default OverNLBADetailLayout;
